import findAncestor from './findAncestor.js';
var initializePopup = function(currentElement){
  var allPopupLinks = currentElement.querySelectorAll('.reveal-overlay-link');
  allPopupLinks.forEach(function(popupLink) {
    popupLink.addEventListener('click', function() {
      var popupContainer = {
        style: {}
      };
      if (popupLink.hasAttribute('open-container-id')) {
        popupContainer = currentElement.getElementById(popupLink.getAttribute('open-container-id'));
      } else if (popupLink.nextElementSibling) {
        popupContainer = popupLink.nextElementSibling;
      }
      if (popupContainer.style.display = "none") {
        popupContainer.style.display = "block";
      } else {
        popupContainer.style.display = "none";
      }
    });
  });
  var allPopupCloseLinks = currentElement.querySelectorAll('.reveal-overlay .close');
  allPopupCloseLinks.forEach(function(popupCloseLink) {
    popupCloseLink.addEventListener('click', function() {
      var revealContainer = findAncestor(popupCloseLink, 'reveal-overlay');
      revealContainer.style.display = "none";
    });
  });
}

export default initializePopup;